import { useCallback, useMemo, useState } from 'react';
import { QContainer, QTabContext, QTabList, QTab, QTabPanel } from '@kw/quokka-ui';
import { Policies } from './Policies';
import { Licenses } from './Licenses';
import { Organizations } from './Organizations';
import { Roles } from './Roles';
import { Users } from './Users';
import { AppResubmission } from './AppResubmission';
import { Inventory } from './Inventory';

type TabKey = 'organizations' | 'users' | 'roles' | 'policies' | 'licenses' | 'inventory' | 'resubmission';

export const CustomerSupport = () => {
  const [activeTab, setActiveTab] = useState<TabKey>('organizations');
  const [visited, setVisited] = useState<Set<TabKey>>(new Set(['organizations']));

  const tabs = useMemo(
    () => [
      { label: 'Organizations', key: 'organizations' as const, render: () => <Organizations /> },
      { label: 'Users', key: 'users' as const, render: () => <Users /> },
      { label: 'Roles', key: 'roles' as const, render: () => <Roles /> },
      { label: 'Policies', key: 'policies' as const, render: () => <Policies /> },
      { label: 'Licenses', key: 'licenses' as const, render: () => <Licenses /> },
      { label: 'Inventory', key: 'inventory' as const, render: () => <Inventory /> },
      { label: 'App Resubmission', key: 'resubmission' as const, render: () => <AppResubmission /> },
    ],
    [],
  );

  const handleTabChange = useCallback((_e: unknown, newValue: TabKey) => {
    setActiveTab(newValue);
    setVisited(prev => {
      if (prev.has(newValue)) return prev;
      const next = new Set(prev);
      next.add(newValue);
      return next;
    });
  }, []);

  return (
    <QContainer maxWidth={false}>
      <QTabContext value={activeTab}>
        <QTabList onChange={handleTabChange}>
          {tabs.map(t => (
            <QTab key={t.key} label={t.label} value={t.key} />
          ))}
        </QTabList>

        {tabs.map(t => (
          <QTabPanel key={t.key} value={t.key}>
            {visited.has(t.key) ? t.render() : null}
          </QTabPanel>
        ))}
      </QTabContext>
    </QContainer>
  );
};
